import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import SoftAvatar from "components/SoftAvatar";
import userImage from "assets/images/illustrations/user.png";
import SoftButton from "components/SoftButton";
import { ApiResponse } from "model/apiResponseModel";
import api from "api/api";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SoftBadge from "components/SoftBadge";
import { convertSecondsToHoursLive } from "helpers/logMessages";
import { Link } from "react-router-dom";
import SearchField from "components/SearchField";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ConfirmDialog from "layouts/leaderboard/components/ConfirmDialog";
import DeleteTableButton from "components/DeleteTableButton";

export default function Streaks() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteStreakId, setDeleteStreakId] = useState("");
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  
    const handleSearch = () => {
        if (searchQuery != "") {
           setCurrentPage(1);
           fetchStreaks(1, searchQuery);
        }
    };

    const handleClearSearch = () => {
        if (searchQuery != "") {
            setCurrentPage(1);
            setSearchQuery("");
            fetchStreaks(1, "");
        }
    };

    const isAddOrEdit = location.pathname.startsWith("/streaks/add") || location.pathname.startsWith("/streaks/edit");
    const isEdit = location.pathname.startsWith("/streaks/edit");

  const fetchStreaks = async (page = 1, search) => {
    try {
      setIsLoading(true);
      let postData = {
        limit,
        page,
      };

      if (search && search.trim() !== "") {
        postData.search = search.trim();
      }

      const response = await api.getStreaksList(postData);
      console.log(response);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        setColumns([
          { name: "title", align: "left" },
          { name: "reward Type", align: "center" },
          { name: "points", align: "center" },
          { name: "badge", align: "center" },
          { name: "status", align: "center" },
          { name: "actions", align: "center" },
        ]);

        setRows(
          response.data.streaks.map((item) => ({
            linkPath: `/streaks`,
            title: (
              <SoftBox display="flex" alignItems="center" px={1} pb={0.5}>
                {/* <SoftAvatar
                  src={item.image[0] || userImage}
                  alt={item.name}
                  size="sm"
                  variant="rounded"
                /> */}
                <SoftBox display="flex" flexDirection="column" ml={2}>
                  <SoftTypography variant="button" fontWeight="medium">
                    {item.title}
                  </SoftTypography>
                  {/* <SoftTypography variant="caption" color="secondary">
                    {item.email}
                  </SoftTypography> */}
                </SoftBox>
              </SoftBox>
            ),
            "reward Type": (
              <SoftTypography 
                variant="caption" 
                color="secondary" 
                fontWeight="medium"
                sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  minHeight: '40px'
                }}
              >
                {item.reward_type}
              </SoftTypography>
            ),
            points: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {item.points ? item?.points : "_"}
              </SoftTypography>
            ),
            badge: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {item.badge || "_"}
              </SoftTypography>
            ),
            status: (
              <SoftBadge
                variant="gradient"
                badgeContent={
                  item.status === "active"
                    ? "Active"
                    : "Inactive"
                }
                color={
                  item.status === "active"
                    ? "success"
                    : "warning"
                }
                size="xs"
              />
            ),
            actions: (
                 <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            >
            <SoftTypography
                component={Link}
                to={`/streaks/edit/?streakId=${item?._id}`}
                variant="caption"
                color="secondary"
                fontWeight="medium"
                sx={{
                display: "flex",
                alignItems: "center",
                minHeight: "40px",
                }}
            >
                Edit
            </SoftTypography>

            <DeleteTableButton
              onClick={() => {
                setDeleteStreakId(item?._id);
                setIsOpenDeleteDialog(true);
              }}
            />
            </Box>
            ),
          }))
        );
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      console.error("Error fetching streaks:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );

    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchStreaks(currentPage, searchQuery);
    }
  }, [currentPage, navigate, searchQuery]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    // console.log(page);
    fetchStreaks(page, searchQuery);
  };

  const handleClose = () => {
        setIsOpenDeleteDialog(false);
      }
    
      const handleConfirmDelete = async () => {
          try {
              setIsDeleting(true);
  
              const data = { 
                  streak_id: deleteStreakId,
              };
              let response = await api.deleteStreakMilestone(data);
              const apiResponse = new ApiResponse(response.status, response.message);
  
              if (apiResponse.status === 1) {
                  // alert(apiResponse.message);
                  setIsOpenDeleteDialog(false);
                  // window.location.href = '/streaks'
                  fetchStreaks(1, "");
              } else {
                  alert(apiResponse.message);
              }
  
              } catch (error) {
                  console.error("Error deleting streak:", error);
              } finally {
                  setIsDeleting(false);
              }
      };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isAddOrEdit ? (<Outlet /> ) : (
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6" width="20%">
                Streaks
              </SoftTypography>
              <SoftBox display="flex" alignItems="center" gap={2}>
                <SearchField
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onSearch={handleSearch}
                onClear={handleClearSearch}
                />
    
                {/* ➕ Add Button */}
                <SoftButton
                variant="gradient"
                color="info"
                startIcon={<AddIcon />}
                onClick={() => navigate("/streaks/add")}
                >
                    Add
                </SoftButton>
            </SoftBox>
              {/* <ProjectFilter status={status} setStatus={setStatus} /> */}
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {isLoading ? (
                <SoftBox
                  display="flex"
                  height="500px"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                >
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    Loading...
                  </SoftTypography>
                </SoftBox>
              ) : rows.length > 0 ? (
                <Table columns={columns} rows={rows} />
              ) : (
                <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    No Streaks Data Found
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
            <SoftBox display="flex" alignItems="center" justifyContent="center" py={2}>
              {/* Previous Button */}
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                sx={{ mx: 1 }}
              >
                Previous
              </SoftButton>

              <SoftButton
                key={currentPage}
                variant="contained"
                color="primary"
                // onClick={() => handlePageClick(pageNumber)}
                sx={{ mx: 0.5 }}
              >
                {currentPage}
              </SoftButton>

              {/* Next Button */}
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
                sx={{ mx: 1 }}
              >
                Next
              </SoftButton>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
      )}
      <ConfirmDialog
        isOpen={isOpenDeleteDialog}
        handleClose={handleClose}
        handleConfirm={handleConfirmDelete}
        isLoading={isDeleting}
        title={
            "Are you sure you want to delete this tier completely?"
        }
        actionText={"Yes, Delete"}
      />
      <Footer />
    </DashboardLayout>
  );
}
